import styles from "./LoadingRequests.module.css";

function LoadingRequests() {
  return (
    <>
      <div className={styles.firstGroup}>
        <div className={styles.cards}>
          <div className={styles.card}>
            <div className={styles.Request_card_not_loaded}>
              <div className={styles.name}>
                <div className={styles.code}>
                  <hr className={styles.cardHeaderLine} />
                  <hr className={styles.cardHeaderLineSmall} />
                </div>
                <div className={styles.underCode}>
                  <hr className={styles.underCodeLine} />
                </div>
                <hr className={styles.mainContnetLine} />
                <hr className={styles.footerLine} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.firstGroup}>
        <div className={styles.cards}>
          <div className={styles.card}>
            <div className={styles.Request_card_not_loaded}>
              <div className={styles.name}>
                <div className={styles.code}>
                  <hr className={styles.cardHeaderLine} />
                  <hr className={styles.cardHeaderLineSmall} />
                </div>
                <div className={styles.underCode}>
                  <hr className={styles.underCodeLine} />
                </div>
                <hr className={styles.mainContnetLine} />
                <hr className={styles.footerLine} />
              </div>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.Request_card_not_loaded}>
              <div className={styles.name}>
                <div className={styles.code}>
                  <hr className={styles.cardHeaderLine} />
                  <hr className={styles.cardHeaderLineSmall} />
                </div>
                <div className={styles.underCode}>
                  <hr className={styles.underCodeLine} />
                </div>
                <hr className={styles.mainContnetLine} />
                <hr className={styles.footerLine} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoadingRequests;
